

















































import Vue from 'vue';
import Component from 'vue-class-component';
import Heading from '../components/Heading.vue';
import SearchBar from '../components/SearchBar.vue';
import TicketRow from '../components/TicketRow.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';

@Component({
  name: 'Home',

  components: {
    Heading,
    SearchBar,
    TicketRow,
    LoadingIndicator,
  },
})
export default class Home extends Vue {
  get tickets() {
    return this.$store.getters.tickets;
  }

  get ticketsLoadingState() {
    return this.$store.getters.ticketsLoadingState;
  }

  mounted() {
    this.$store.dispatch('fetchTickets');
  }

  onTicketSearch(searchValue: string) {
    this.$store.dispatch('searchTickets', searchValue);

    this.$gtag.event('search', {
      event_category: 'Search', // eslint-disable-line @typescript-eslint/camelcase
      event_label: searchValue, // eslint-disable-line @typescript-eslint/camelcase
    });
  }

  changePage(page = 1) {
    this.$store.commit('setTicketsPage', page);
    this.$store.dispatch('fetchTickets');
  }
}
